export default __webpack_public_path__ + "static/media/42fc703a4713d9a90c79f00db95b39f5.7a1ce053.svg";